import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { EmperorUIButtonTypes } from '../button';
import { EmperorThemeColor } from '../models';

export enum QuotePresentationIconColor {
  Quoted = 'quoted',
  Checkout = 'checkout',
  Bound = 'bound',
  NoQuote = 'no-quote',
  Error = 'error',
}

@Component({
  selector: 'emperor-quote-presentation-slim',
  templateUrl: './quote-presentation-slim.component.html',
  styleUrls: ['./quote-presentation-slim.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuotePresentationSlimComponent {
  @Input() headline?: string;
  @Input() price?: string;
  @Input() costCycle: string;
  @Input() carrierName: string;
  @Input() carrierLogo: string;
  @Input() supplierLogo?: string;
  @Input() supplierName?: string;
  @Input() showActionButton = false;
  @Input() disableActionButton = false;
  @Input() showDownloadQuote = false;
  @Input() buttonText?: string;
  @Input() logoIcon?: string;
  @Input() logoIconColor?: string;
  @Input() subtitleText?: string;
  @Input() showViewDetails = false;
  @Input() quoteType?: string;
  @Input() ineligibleQuote = false;
  @Input() isLoading = false;

  @Output() viewDetailsClicked = new EventEmitter<void>();
  @Output() actionButtonClicked = new EventEmitter<void>();
  @Output() downloadQuoteClick = new EventEmitter<void>();

  emperorUiButtonType = EmperorUIButtonTypes;
  emperorThemeColor = EmperorThemeColor;

  get displayButtonText(): string {
    return this.buttonText || 'Continue';
  }

  onViewDetailsClicked() {
    this.viewDetailsClicked.emit();
  }

  onActionButtonClicked() {
    this.actionButtonClicked.emit();
  }

  onDownloadQuoteClick() {
    this.downloadQuoteClick.emit();
  }
}
